import { createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "col-xxl-12 mb-5" }, null, -1)
const _hoisted_2 = { class: "col-xxl-12" }
const _hoisted_3 = { class: "card-header border-0 pt-5" }
const _hoisted_4 = { class: "card-body py-3 row" }
const _hoisted_5 = { class: "col-xxl-6" }
const _hoisted_6 = /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column mb-5" }, [
  /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Your Inventory")
], -1)
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_9 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-225px rounded-start" }, "Product"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-100px" }, "Remaining"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-100px" }, "Quantity"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-100px" }, "Action")
  ])
], -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "col-xxl-2" }, null, -1)
const _hoisted_11 = { class: "col-xxl-4" }
const _hoisted_12 = /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column mb-5" }, [
  /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Transfer Cart")
], -1)
const _hoisted_13 = { class: "row mb-5" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label  fw-bold fs-6" }, "Destination Usid: ", -1)
const _hoisted_15 = { class: "col-lg-8" }
const _hoisted_16 = { class: "row mb-5" }
const _hoisted_17 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label  fw-bold fs-6" }, "Fullname: ", -1)
const _hoisted_18 = { class: "col-lg-6" }
const _hoisted_19 = {
  class: "col-lg-12 col-form-label fw-bold fs-6",
  id: "transferProductFullname"
}
const _hoisted_20 = { class: "table-responsive" }
const _hoisted_21 = {
  class: "table align-middle gs-0 gy-4",
  id: "transferSummaryTable"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-225px rounded-start" }, "Product"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-100px" }, "Quantity"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-100px" })
  ])
], -1)
const _hoisted_23 = {
  key: 0,
  class: "row"
}
const _hoisted_24 = {
  key: 0,
  href: "javascript:void(0);",
  style: {"background-color":"grey"},
  class: "btn btn-success btn-sm"
}
const _hoisted_25 = {
  key: 1,
  class: "row"
}
const _hoisted_26 = { class: "notice d-flex bg-light-warning rounded border-warning border border-dashed mb-10 p-6" }
const _hoisted_27 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_28 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_29 = { class: "fw-bold" }
const _hoisted_30 = /*#__PURE__*/_createVNode("h4", { class: "text-gray-800 fw-bolder" }, "Please Confirm Transfer!", -1)
const _hoisted_31 = { class: "fs-6 text-gray-600" }
const _hoisted_32 = {
  class: "row col-md-12",
  align: "center"
}
const _hoisted_33 = /*#__PURE__*/_createTextVNode("   ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_EstoreTabNavigator = _resolveComponent("EstoreTabNavigator")
  const _component_font = _resolveComponent("font")
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: [_ctx.widgetClasses, "card"]
      }, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_EstoreTabNavigator, { "widget-classes": "card-xxl-stretch mb-5 mb-xxl-8" })
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("div", _hoisted_7, [
              _createVNode("table", _hoisted_8, [
                _hoisted_9,
                _createVNode("tbody", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                    return (_openBlock(), _createBlock("tr", { key: index }, [
                      _createVNode("td", null, "   " + _toDisplayString(item.product), 1),
                      _createVNode("td", null, _toDisplayString(Math.round(item.quantity)), 1),
                      _createVNode("td", null, [
                        _withDirectives(_createVNode("input", {
                          class: "form-control dashboardFontStyle",
                          type: "text",
                          id: 'store_count_'+item.prodcode,
                          name: "",
                          style: {"width":"50px"},
                          "onUpdate:modelValue": ($event: any) => (_ctx.store_count[index] = $event)
                        }, null, 8, ["id", "onUpdate:modelValue"]), [
                          [_vModelText, _ctx.store_count[index]]
                        ])
                      ]),
                      _createVNode("td", null, [
                        _createVNode("a", {
                          href: "javascript:void(0);",
                          onClick: ($event: any) => {_ctx.addTableRow(item.prodcode, item.product, index, item.quantity);},
                          class: "btn btn-success btn-sm dashboardFontStyle"
                        }, "+", 8, ["onClick"])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _hoisted_10,
          _createVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode("div", _hoisted_15, [
                _withDirectives(_createVNode("input", {
                  class: "form-control dashboardFontStyle",
                  type: "text",
                  onBlur: _cache[1] || (_cache[1] = ($event: any) => {_ctx.getDestinationFullname();}),
                  placeholder: "Enter destination usid here...",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.destination_usid = $event))
                }, null, 544), [
                  [_vModelText, _ctx.destination_usid]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode("div", _hoisted_18, [
                _createVNode(_component_font, { color: "green" }, {
                  default: _withCtx(() => [
                    _createVNode("label", _hoisted_19, _toDisplayString(_ctx.destination_fullname), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createVNode("div", _hoisted_20, [
              _createVNode("table", _hoisted_21, [
                _hoisted_22,
                _createVNode("tbody", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.transferCart, (item, index) => {
                    return (_openBlock(), _createBlock("tr", {
                      key: index,
                      id: 'transferCart_' + item.prodcode,
                      class: "transfer-cart-list"
                    }, [
                      _createVNode("td", {
                        id: 'prod_name_' + item.prodcode
                      }, "   " + _toDisplayString(item.prodname), 9, ["id"]),
                      _createVNode("td", {
                        id: 'prod_count_'+item.prodcode
                      }, _toDisplayString(Math.round(item.quantity)), 9, ["id"]),
                      _createVNode("td", null, [
                        _createVNode("a", {
                          href: "javascript:void(0);",
                          onClick: ($event: any) => {_ctx.removeTableRow(item.prodcode);},
                          class: "btn btn-danger btn-sm dashboardFontStyle"
                        }, "X", 8, ["onClick"])
                      ])
                    ], 8, ["id"]))
                  }), 128))
                ])
              ])
            ]),
            (!_ctx.isShowConfirmation)
              ? (_openBlock(), _createBlock("div", _hoisted_23, [
                  (!_ctx.enabledTransferButton)
                    ? (_openBlock(), _createBlock("a", _hoisted_24, "Transfer"))
                    : _createCommentVNode("", true),
                  (_ctx.enabledTransferButton)
                    ? (_openBlock(), _createBlock("a", {
                        key: 1,
                        href: "javascript:void(0);",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.showTransferProductConfirmation();}),
                        class: "btn btn-success btn-sm"
                      }, "Transfer"))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isShowConfirmation)
              ? (_openBlock(), _createBlock("div", _hoisted_25, [
                  _createVNode("div", _hoisted_26, [
                    _createVNode("span", _hoisted_27, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
                    ]),
                    _createVNode("div", _hoisted_28, [
                      _createVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _createVNode("div", _hoisted_31, [
                          _createVNode("p", null, "Are you sure you want to proceed with the transfer of products to " + _toDisplayString(_ctx.destination_usid.toUpperCase()) + " ?", 1)
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_32, [
                    _createVNode("a", {
                      href: "javascript:void(0);",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.proceedConfirmTransferProduct();}),
                      class: "btn btn-success btn-sm col-md-5"
                    }, "Yes"),
                    _hoisted_33,
                    _createVNode("a", {
                      href: "javascript:void(0);",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.cancelConfirmTransferProduct();}),
                      class: "btn btn-danger btn-sm col-md-5"
                    }, "No")
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 2)
    ], 512), [
      [_vShow, !_ctx.loading && _ctx.isBCOAccount ]
    ])
  ], 64))
}